<script setup lang="ts">
import { getPriceLabel } from "~/utils/subscription";

export interface SubscriptionBuyDetailsProps {
  price?: number;
  currency?: string;
  expirationDate?: string;
}

const props = defineProps<SubscriptionBuyDetailsProps>();
const { t } = useI18n();
</script>

<template>
  <div>
    <div class="hr my-6" />

    <div class="flex items-center justify-between mb-4">
      <div class="text-secondary text-body-medium">
        {{ t('pages.account_subscription.label_plan_amount') }}
      </div>
      <div v-if="props.price && props.currency" class="text-secondary text-base font-medium uppercase">
        {{ getPriceLabel(props.price, props.currency) }}
      </div>
    </div>
    <!-- TODO: Taxes require BE
    <div class="flex items-center justify-between mb-4">
      <div class="text-secondary text-body-medium">
        {{ t('pages.account_subscription.label_taxes') }}
      </div>
      <div v-if="props.subscription" class="text-secondary text-body-medium">
        {{ `${props.subscription.currency.toUpperCase()} 1` }}
      </div>
    </div> -->
    <div class="flex items-center justify-between">
      <div class="text-main text-base font-bold">
        {{ t('pages.account_subscription.label_total_billed') }}
      </div>
      <div v-if="props.price && props.currency" class="text-main text-base font-bold uppercase">
        {{ getPriceLabel(props.price, props.currency) }}
      </div>
    </div>
    <div class="hr my-6" />

    <div class="mb-6 text-xs text-secondary">
      {{ props.expirationDate }}
    </div>
  </div>
</template>
